/*
 * Copyright (c) 2024. Tooling Team
 */

import PropTypes from "prop-types";
import { ModalDialog } from "@uhg-abyss/web/ui/ModalDialog";
import { Button } from "@uhg-abyss/web/ui/Button";
import { Layout } from "@uhg-abyss/web/ui/Layout";

export default function DeleteRowForm(props) {
  const deleteRows = () => {
    const { records } = props.formData;
    props.deleteCallback({
      records,
    });
  };

  return (
    <ModalDialog
      isOpen={props.isOpen}
      header="Delete Row(s)"
      onClose={props.onClose}
      footer={
        <Layout.Group alignLayout="right">
          <Button onClick={deleteRows} variant="outline" color="neutral">
            Yes
          </Button>
          <Button onClick={props.onClose} variant="outline" color="neutral">
            Cancel
          </Button>
        </Layout.Group>
      }
    >
      Are you sure you want to delete the selected row(s)?
    </ModalDialog>
  );
}

DeleteRowForm.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  deleteCallback: PropTypes.func,
  formData: PropTypes.object,
};
